export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("bb_user") || "null");
  } catch {
    return null;
  }
};

export const getToken = () => localStorage.getItem("bb_token") || "";

export const setSession = (token, user) => {
  localStorage.setItem("bb_token", token);
  localStorage.setItem("bb_user", JSON.stringify(user));
};

export const logout = () => {
  localStorage.removeItem("bb_token");
  localStorage.removeItem("bb_user");
  window.location.href = "/login";
};

export const homeForRole = (role) => {
  // Normalize legacy "Client" -> "Coca-Cola" everywhere (tokens issued before the F12 rename
  // still carry role="Client"; treat them as Coca-Cola so no login breaks).
  const r = role === "Client" ? "Coca-Cola" : role;
  if (r === "SuperAdmin") return "/portfolio";
  if (r === "Admin") return "/admin";
  // ITEM D.15-17 (2026-02-29): Supervisor renamed to Coordinator, Project Lead to Manager
  // (display + URL only — backend role strings unchanged). Both share the same dashboard page.
  if (r === "Supervisor" || r === "IT") return "/coordinator";
  if (r === "Project Lead") return "/manager";
  if (r === "Coca-Cola") return "/coca-cola";
  if (r === "Promoter") return "/promoter";
  return "/login";
};

// ITEM D.15-16 (2026-02-29): map internal role string → display label
export const roleDisplayLabel = (role) => {
  if (role === "Supervisor") return "Co-ordinator";
  if (role === "Project Lead") return "Manager";
  if (role === "Client") return "Coca-Cola";
  return role;
};

// Legacy alias — any code that still checks role==='Client' should route through this.
export const isCocaColaRole = (role) => role === "Coca-Cola" || role === "Client";
